/**
 * Securely opens an external URL in a new tab/window
 * Prevents reverse tabnabbing attacks by ensuring window.opener is null
 * 
 * @param url - The URL to open
 * @param target - The target window (default: "_blank")
 */
export const openExternalLink = (url: string, target: string = "_blank"): void => {
  // Create a temporary anchor element with security attributes
  const link = document.createElement("a");
  link.href = url;
  link.target = target;
  link.rel = "noopener noreferrer"; // Prevents window.opener access and referrer leakage
  
  // Append to body, click, then remove
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

